import React from 'react';
import './EarnPage.scss';
import EarnTabsNavigation, {EarnTabValue, useCurrentEarnTab} from "./EarnTabs/EarnTabsNavigation";
// eslint-disable-next-line react/jsx-pascal-case
import NXUSD_USDC_LP_Staking from "./NXUSD_USDC_LP_Staking/NXUSD_USDC_LP_Staking";
// eslint-disable-next-line react/jsx-pascal-case
import NRS_USDC_LP_Staking from "./NRS_USDC_LP_Staking/NRS_USDC_LP_Staking";
import NRSLockPage from "./NRSLock/NRSLockPage";

const EarnPage = () => {

    const currentTab = useCurrentEarnTab()

    return (
        <div className="EarnPage content-container justify-start flex-col flex-grow">
            <EarnTabsNavigation/>
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            {currentTab === EarnTabValue.NXUSD_USDC_LP_Staking && <NXUSD_USDC_LP_Staking />}
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            {currentTab === EarnTabValue.NRS_USDC_LP_Staking && <NRS_USDC_LP_Staking />}
            {currentTab.length && currentTab.startsWith(EarnTabValue.NRS_Locking) && <NRSLockPage />}
        </div>
    );
}

export default EarnPage;